import { useCentralApi, useCurrentUser } from "hooks/shared";
import { useSnackbar } from "@sagecentral/core-ui";

const useChangePrimaryWorkItemResourceAllocation = () => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);
    const { displaySnackbar } = useSnackbar();

    const handleChangePrimaryResource = async (workitemId: number, resourceAllocationId: number, resourceId: string, draft?: boolean) => {
        const uri = draft
            ? `/api/v3/drafts/workitems/${workitemId}/resource-allocation/primary/${resourceAllocationId}`
            : `/api/v3/workitems/${workitemId}/resource-allocation/primary/${resourceAllocationId}`;
        const resp = await fetcher(uri, {
            method: 'PATCH',
            body: JSON.stringify(resourceId),
        });

        if(resp.ok){
            displaySnackbar('success', 'Primary resource changed successfully');
            return true;
        }

        displaySnackbar('error', 'Primary resource change failed ');
        return false;
    };

    return handleChangePrimaryResource;
};

export default useChangePrimaryWorkItemResourceAllocation;